let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("du1Vi")).then(() => parcelRequire('jeFMu'));